import axios from "axios"
import { alertMsg } from "./basicUtils";

export const BASE_URL = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_SERVER_URL : process.env.REACT_APP_LIVE_SERVER_URL;

export const axiosFetch = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

axiosFetch.interceptors.request.use(
    config => {
        return config;
    },
    error => Promise.reject(error)
);

axiosFetch.interceptors.response.use(
    resp => resp,
    async (error) => {
        if (error?.name !== 'CanceledError') {
            handleApiError(error)
            return Promise.reject(error);
        }
    }
);

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});

axiosPrivate.interceptors.request.use(
    config => {
        return config;
    },
    error => Promise.reject(error)
);

axiosPrivate.interceptors.response.use(
    resp => resp,
    async (error) => {
        if (error?.name !== 'CanceledError') {
            handleApiError(error)
            return Promise.reject(error);
        }
    }
);

export const handleApiError = (error) => {
    if (error?.response?.data?.message) {
        let serverError = error.response.data.message;
        if (typeof serverError == 'object') {
            alertMsg(
                Object.keys(serverError).map(ele => {
                    return typeof serverError[ele] == "string" ? serverError[ele] : serverError[ele].join('\n')
                }).join('\n'), 'error'
            )
        } else {
            if (serverError === "Token prefix missing") {
                return
            }
            if (serverError === "Access token expired") {
                return
            }
            if (serverError === 'Your account is inactive') {
                return
            }
            alertMsg(serverError, 'error')
        }
    } else {
        alertMsg(error.message, 'error')
    }
}

export const uploadPresigned = async (upload, onUploadProgress) => {
    try {
        await axios.put(upload.presigned.data, upload.file,
            {
                headers: { "x-amz-acl": "public-read" },
                onUploadProgress: onUploadProgress
            })
        return upload.presigned.object;
    } catch (error) {
        console.error(error)
        return false
    }
}

export const getRefreshTokenFromHeaders = (headers) => {
    let cookies = headers["set-cookie"]
    if (cookies) {
        for (let element of cookies) {
            if (element.startsWith("refresh_token")) {
                return element
            }
        }
    }
    return false
}
